import React from 'react';
import {
  Container, Button, FontAwesomeIcon, IconsSolid
} from '@jkhy/vsg-design-system';
import { getInternetExplorerVersion, goToIENotSupported, isNullOrWhiteSpace } from '../../utils/helper';
import './page-missing.css';

type PageMissingProps = {
  statusCode?: string
  errMsg?: string
}

const PageMissing = (props: PageMissingProps) => {
  if (getInternetExplorerVersion() !== -1) {
    goToIENotSupported(props);
  }
  const { statusCode, errMsg, } = props;
  return (
    <Container dataUI="PageMissingContainer">
      <div className="page-missing-container">
        <div className="page-missing-circle mb-1">
          <FontAwesomeIcon icon={IconsSolid.faBan} />
        </div>
        <h1 className="mb-2">
          {`${statusCode || '404'} Error`}
        </h1>
        <p className="mb-2">{errMsg || 'The page you are looking for was not found.'}</p>
        { !isNullOrWhiteSpace(window.institutionId)
          && (
          <Button dataUI="PageMissingBackToPortal" link={{ path: '/', title: 'Back to Portal', }}>
            Back to Portal
          </Button>
          ) }
      </div>
    </Container>
  );
};

export default PageMissing;
